export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7016899222003eb6ddb6b3cbba54c392b8b6a19765&name=pushAdClickData!'